import MoleculeStructure from "../../Data/MoleculeStructure";
import { ReactComponent as ExportIcon } from '../../../assets/Icons/adornments/Download.svg';
import { MouseEvent, useEffect, useState } from "react";
import { downloadStructureImage } from "../../../utils/formattingFns";
import { MoleculeHighlightingType } from "../../../routes/Resultsets/pages/IndividualResultset";
import ImageToggle from "../../Buttons/ImageToggle";

export default function StructureComponent({
    value,
    moleculeHighlightingData
}: {
    value: string,
    moleculeHighlightingData?: { name: string, data: MoleculeHighlightingType }[],
}) {
    const [ highlightingData, setHighlightingData ] = useState<{ name: string, data: MoleculeHighlightingType }[]>([]);
    const [ selectedSmilesIndex, setSelectedSmilesIndex ] = useState(0);
    const [ selectedIndex, setSelectedIndex ] = useState(0);

    useEffect(() => {
        if (moleculeHighlightingData) {
            const sortedHighlightingData = [...moleculeHighlightingData].sort((a,b) => {
                if (a.name > b.name) {
                    return 1;
                } else if (a.name < b.name) {
                    return -1;
                } else {
                    return 0;
                }
            });

            setHighlightingData(sortedHighlightingData);
            
            if (sortedHighlightingData.length > 0) {
                const firstDataframeSmiles = sortedHighlightingData[0].data.dataframe.smiles;
                let index = 0;
                Object.keys(firstDataframeSmiles).forEach(key => {
                    const smiles = firstDataframeSmiles[Number(key)];
                    if (smiles === value) {
                        index = Number(key);
                    }
                });

                setSelectedSmilesIndex(index);
            }   
        }
    }, [moleculeHighlightingData, value]);

    const getAtomBondImportance = (data: MoleculeHighlightingType) => {
        const importanceObj = data.dataframe.atom_bond_importance;
        return importanceObj[selectedSmilesIndex];
    }

    


    return (
        <div className="w-full flex flex-col justify-start items-end gap-3 p-6">
            <div className={`w-full flex ${highlightingData.length > 0 ? 'justify-between' : 'justify-end'} items-center gap-3`}>
                {highlightingData.length > 0 && (
                    <div className='flex justify-start items-center gap-4'>
                        <ImageToggle 
                            selectedIndex={selectedIndex}
                            setSelectedIndex={setSelectedIndex}
                            totalIndices={highlightingData.length}
                        />
                        <p>{highlightingData[selectedIndex].name}</p>
                    </div>
                )}
                <button onClick={(e:MouseEvent<HTMLButtonElement>) => downloadStructureImage(e, value)} className="flex justify-end items-center gap-2 text-primary hover:text-highlight transition-all">
                    <div className="w-[12px]"><ExportIcon/></div>
                    <p className="text-[12px] font-medium">Download image</p>
                </button>
            </div>
            <div className="w-full flex justify-center items-center">
                {highlightingData.length === 0 ? (
                    <MoleculeStructure smiles={value} height={400} width={400}/>
                ) : (
                    <>
                    {highlightingData.map((h,i) => {
                        if (i === selectedIndex) {
                            return (
                                <MoleculeStructure atom_bond_importance={getAtomBondImportance(h.data)} smiles={value} height={400} width={400}/>
                            )
                        } else {
                            return null;
                        }
                    })}
                    </>
                )}
                
            </div>
        </div>
    )
}